// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "toastNotification" + "." + "0b84d9ea" + ".js";
};